<template>
  <el-dialog
    title="停用广告"
    :visible.sync="dialogVisible"
    width="80%"
    :before-close="handleClose"
  >
    <div v-if="dialogVisible" class="dialog-content">
      <!-- 计划表格 -->
      <div class="table-section">
        <h3 class="table-title">计划列表</h3>
        <el-table
          v-loading="loading"
          :data="promotionList"
          border
          style="width: 100%;"
          max-height="400"
        >
          <el-table-column
            prop="promotion_id"
            label="计划ID"
            align="center"
            width="200"
          />
          <el-table-column
            prop="promotion_name"
            label="计划名称"
            align="center"
            min-width="200"
          />
          <!-- <el-table-column
            prop="is_open"
            label="状态"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              <el-tag :type="scope.row.is_open ? 'success' : 'danger'">
                {{ scope.row.is_open ? '开启' : '关闭' }}
              </el-tag>
            </template>
          </el-table-column> -->
        </el-table>
      </div>

      <!-- 项目表格 -->
      <div class="table-section">
        <h3 class="table-title">项目列表</h3>
        <el-table
          v-loading="loading"
          :data="projectList"
          border
          style="width: 100%;"
          max-height="400"
        >
          <el-table-column
            prop="project_id"
            label="项目ID"
            align="center"
            width="200"
          />
          <el-table-column
            prop="project_name"
            label="项目名称"
            align="center"
            min-width="200"
          />
          <!-- <el-table-column
            prop="is_open"
            label="状态"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              <el-tag :type="scope.row.is_open ? 'success' : 'danger'">
                {{ scope.row.is_open ? '开启' : '关闭' }}
              </el-tag>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定停用</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getAllPromotions, closeAd } from '@/api/notify.js'

export default {
  name: 'StopPromotionDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    accountId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      promotionList: [],
      projectList: []
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal && this.accountId) {
        this.$nextTick(() => {
          this.getData()
        })
      }
    },
    dialogVisible(newVal) {
      if (!newVal) {
        this.$emit('update:visible', false)
        this.promotionList = []
        this.projectList = []
      }
    }
  },
  methods: {
    // 获取数据
    async getData() {
      if (!this.accountId) {
        return
      }
      this.loading = true
      try {
        const data = await getAllPromotions({ account_id: this.accountId })
        // 根据接口返回的数据结构处理
        if (data.data) {
          this.promotionList = data.data.promotion || data.data.promotion || []
          this.projectList = data.data.project || data.data.project || []
        } else {
          this.promotionList = data.promotion || data.promotion || []
          this.projectList = data.project || data.project || []
        }
      } catch (err) {
        console.error('获取计划和项目列表失败:', err)
        this.$message.error('获取数据失败')
        this.promotionList = []
        this.projectList = []
      }
      this.loading = false
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
      this.$emit('update:visible', false)
    },
    // 确定停用
    async handleConfirm() {
      if (!this.accountId) {
        this.$message.warning('缺少广告主ID')
        return
      }

      // 提取计划ID和项目ID
      const promotionIds = this.promotionList.map(item => String(item.promotion_id)).filter(id => id)
      const projectIds = this.projectList.map(item => String(item.project_id)).filter(id => id)

      // 如果计划和项目都为空，提示用户
      // if (promotionIds.length === 0 && projectIds.length === 0) {
      //   this.$message.warning('没有可停用的计划和项目')
      //   return
      // }

      this.loading = true
      try {
        const params = {
          account_id: String(this.accountId)
        }

        // 只有当数组不为空时才添加
        if (promotionIds.length > 0) {
          params.promotion_ids = promotionIds
        }
        if (projectIds.length > 0) {
          params.project_ids = projectIds
        }

        const res = await closeAd(params)

        if (res.code === 0 || res.success) {
          this.$message.success('停用请求成功')
          // 触发父组件刷新列表
          this.$emit('refresh')
          this.handleClose()
        } else {
          this.$message.error(res.message || '停用失败')
        }
      } catch (err) {
        console.error('停用失败:', err)
        this.$message.error(err.message || '停用失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.dialog-content {
  padding: 10px 0;
}

.table-section {
  margin-bottom: 30px;
}

.table-section:last-child {
  margin-bottom: 0;
}

.table-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 15px;
}

.dialog-footer {
  text-align: right;
}
</style>

